module.exports = __webpack_public_path__ + "dist/assets/img/H.bdd48ae2.svg";